import React from 'react';
export function MethodSection() {
  const steps = [{
    number: '1',
    title: 'Reflexiona',
    description: 'Una verdad espiritual profunda',
    detail: 'Cada día descubres una enseñanza que transforma tu perspectiva'
  }, {
    number: '2',
    title: 'Afirma',
    description: 'Una declaración que renueva la mente',
    detail: 'Palabras poderosas que reprograman tu diálogo interno'
  }, {
    number: '3',
    title: 'Actúa',
    description: 'Una práctica espiritual diaria',
    detail: 'Acciones simples que anclan tu fe en la realidad'
  }];
  return <section className="section-card" data-id="element-91">
      <div className="max-w-5xl mx-auto" data-id="element-92">
        <div className="text-center mb-12" data-id="element-93">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-94">
            Qué Incluye & Cómo Funciona
          </h2>
          <p className="text-lg text-blue-100 max-w-2xl mx-auto" data-id="element-95">
            Un método simple y profundo de 3 pasos que solo te toma 10-15
            minutos al día. No es teoría. Es transformación práctica.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-96">
          {steps.map(step => <div key={step.number} className="bg-gradient-to-br from-blue-900/40 to-purple-900/40 backdrop-blur-sm border border-blue-400/20 rounded-xl p-6 hover:border-yellow-400/40 transition-all duration-300 hover:transform hover:scale-105" data-id="element-97">
              <div className="w-12 h-12 bg-yellow-400 text-gray-900 rounded-full flex items-center justify-center font-bold text-xl mb-4" data-id="element-98">
                {step.number}
              </div>

              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-99">
                {step.title}
              </h3>

              <p className="text-yellow-300 font-semibold mb-3" data-id="element-100">
                {step.description}
              </p>

              <p className="text-blue-100" data-id="element-101">{step.detail}</p>
            </div>)}
        </div>

        <div className="text-center mt-8" data-id="element-102">
          <p className="text-blue-200 text-sm" data-id="element-103">
            ⏱️ Solo 10-15 minutos al día · 📖 30 días de contenido · ✨
            Resultados desde el Día 1
          </p>
        </div>
      </div>
    </section>;
}